import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import {
    withStyles,
    makeStyles,
    createStyles,
    useTheme,
} from "@material-ui/core/styles";
import clsx from "clsx";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import AppBar from "@material-ui/core/AppBar";
import { Tabs, Tab, Popover, MenuItem } from "@material-ui/core";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import { PipeChatSamll } from "../../shared";
import { CommonCss } from "../../services/CommonCss";
import { getDefaultTab } from "../../services/FunctionServices";
import { getCookie } from "../../services/Cookies";
import Avatar from '@material-ui/core/Avatar';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

const useStyles = makeStyles((theme) => ({
    tabRoot: {
        backgroundColor: "#fff",
        opacity: 1,
        boxShadow: "0px 0px 6px 0px #c0c0c0!important",
        marginBottom: 2,
        marginTop: 2,
        marginLeft: 2,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        fontWeight: "bold",
        textTransform: "capitalize",
    },
    alertTabRoot: {
        color: "#ffffff",
        fontSize: "16px !important",
        lineHeight: "1 !important",
    },
    appBarRoot: {
        color: "#000",
        boxShadow: "0 0 0 red !important",
        backgroundColor: "transparent !important",
    },
    paper: {
        padding: "6px",
        // textAlign: "center",
        color: theme.palette.text.secondary,
        marginLeft: 2,
        borderTopLeftRadius: 0,
    },
    paperHeader: {
        backgroundColor: "transparent",
        boxShadow: " 0 0 0 0 #eee !important",
    }
}));

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box px={3} pt={2} component="div">
                    <Typography component="div">{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    const serviceTypes = getCookie("serviceTypes").split(',');
    let showTab = false;
    if (getDefaultTab().indexOf(index) > -1)
        showTab = true;
    let res = {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`
    };
    if (!showTab) {

        res = {
            id: `simple-tab-${index}`,
            "aria-controls": `simple-tabpanel-${index}`,
            "style": { display: "none" }
        };
    }

    return res;
}

export default function ReportStatus(props) {
    const classes = useStyles();
    const commonClasses = CommonCss();
    const history = useHistory();
    const heightNo = "159px";

    const { reportStatusDetails: { fuelAnalysisReportStatus, lubeAnalysisReportStatus, totAnalysisReportStatus }, reportObj, tabActive, reporSubType, getChangedTab } = props;
    const fuelArray = fuelAnalysisReportStatus.filter((row) => row.caseCount != 0);
    const lubeArray = lubeAnalysisReportStatus.filter((row) => row.caseCount != 0);
    const totArray = totAnalysisReportStatus.filter((row) => row.caseCount != 0);

    function onReportDetails(data, type, subType) {
        history.push({
            pathname: "/dashboard/reports",
            data: data,
            type: type,
            subType: subType
        });
    }
    const handleChange = (event, newValue) => {
        setValue(newValue);
        tabActive(newValue);
        getChangedTab(newValue)
    };

    const [value, setValue] = React.useState(props.dashtab ? props.dashtab :reporSubType == "Tot" ? 2 : reporSubType == "Lube" ? 1 : 0);
    const fuelIcon = (value == 0 ? "/assets/svg/fqt-new-1-selected.svg" : "/assets/svg/fqt-new-1.svg");
    const lubeIcon = (value == 1 ? "/assets/svg/ocm-new-selected.svg" : "/assets/svg/ocm-new.svg");
    const TransIcon = (value == 2 ? "/assets/svg/tot-new-selected.svg" : "/assets/svg/tot-new.svg");

    const [open, setOpen] = React.useState(false);
    const [state, setState] = React.useState({
        value: "One",
        label: "Transoil",
        content: "One",
        anchorEl: null
    });

    /** end for transoil tab dropdown */

    return (
        <div>
            <Box component="div" display="bloc"  >
                <Paper className={clsx(classes.paperHeader)}>
                    <AppBar position="static" className={classes.appBarRoot}>
                        <Tabs className="sample-stat-tab"
                            value={value}
                            onChange={handleChange}
                            aria-label="simple tabs example"
                        >
                            <Tab
                                className={classes.tabRoot}
                                label="Fuel Analysis"
                                icon={<Avatar className="tab-ava-img" src={fuelIcon} />}
                                {...a11yProps(0)}
                            />
                            <Tab
                                className={classes.tabRoot}
                                label="Lube Analysis"
                                icon={<Avatar className="tab-ava-img" src={lubeIcon} />}
                                {...a11yProps(1)}
                            />
                            <Tab
                                className={classes.tabRoot}
                                label="VPS Power"
                                //label={state.label}
                                icon={<Avatar className="tab-ava-img" src={TransIcon} />}
                                //icon={<ArrowDropDownIcon className="tab-ava-img" onClick={handleClicked} />}
                                //onClick={() => setState({ content: state.label })}
                                {...a11yProps(2)}
                            />
                        </Tabs>

                    </AppBar>
                </Paper>
                <Paper className={classes.paper}>
                    <TabPanel value={value} index={0}>
                        <Box component="div" display="flex" pb={2} alignItems="center">
                            {fuelAnalysisReportStatus.length && fuelArray.length
                                ? fuelAnalysisReportStatus[0].typeOfCase.map((item) => (
                                    <Box key={item.title} component="div" pr={2}>
                                        <svg height="10" width="10">
                                            <circle cx="5" cy="5" r="4" fill={item.color} />
                                        </svg>
                                        <Box component="span" pl={1}>
                                            {item.title}
                                        </Box>
                                    </Box>
                                ))
                                : ""}
                        </Box>
                        <Box
                            component="div"
                            display="flex"
                            style={{ cursor: "pointer" }}
                        >
                            {fuelAnalysisReportStatus.length && fuelArray.length
                                ? fuelAnalysisReportStatus.map((item) => {
                                    const itemList = item.typeOfCase.filter(item => item.value != 0);
                                    return itemList.length ? (
                                        <Box
                                            component="div"
                                            style={{ cursor: "pointer" }}
                                            key={item.title + Math.random() * 100}
                                            onClick={() => {
                                                // onReportDetails(reportObj, "ReportStatus", "Fuel");
                                            }}
                                        >
                                            <PipeChatSamll
                                                typeOfCase={item.typeOfCase}
                                                caseCount={item.caseCount}
                                                text1={item.text1}
                                                text2={item.text2}
                                            />
                                            <Box
                                                component="span"
                                                fontWeight="bold"
                                                fontSize={20}
                                                py={1}
                                                display="block"
                                                textAlign="center"
                                            >
                                                {item.title}
                                            </Box>
                                        </Box>
                                    ) : ""
                                })
                                : (<Box height={heightNo} display="flex" justifyContent="center" className="full-w-align-c">
                                    <Box className="full-w-align-c">No Record Found </Box>
                                </Box>)}
                        </Box>
                    </TabPanel>
                    <TabPanel value={value} index={1}>
                        <Box component="div" display="flex" pb={2} alignItems="center">
                            {lubeAnalysisReportStatus.length && lubeArray.length
                                ? lubeAnalysisReportStatus[0].typeOfCase.map((item) => (
                                    <Box key={item.title} component="div" pr={2}>
                                        <svg height="10" width="10">
                                            <circle cx="5" cy="5" r="4" fill={item.color} />
                                        </svg>
                                        <Box component="span" pl={1}>
                                            {item.title}
                                        </Box>
                                    </Box>
                                ))
                                : ""}
                        </Box>
                        <Box
                            component="div"
                            display="flex"
                            style={{ cursor: "pointer" }}
                        >
                            {lubeAnalysisReportStatus.length && lubeArray.length
                                ? lubeAnalysisReportStatus.map((item) => {
                                    const itemList = item.typeOfCase.filter(item => item.value != 0);
                                    return itemList.length ? (
                                        <Box
                                            component="div"
                                            style={{ cursor: "pointer" }}
                                            key={item.title + Math.random() * 100}
                                            onClick={() => {
                                                // onReportDetails(reportObj, "ReportStatus", "Lube");
                                            }}
                                        >
                                            <PipeChatSamll
                                                typeOfCase={item.typeOfCase}
                                                caseCount={item.caseCount}
                                                text1={item.text1}
                                                text2={item.text2}
                                            />
                                            <Box
                                                component="span"
                                                fontWeight="bold"
                                                fontSize={20}
                                                py={1}
                                                display="block"
                                                textAlign="center"
                                            >
                                                {item.title}
                                            </Box>
                                        </Box>
                                    ) : ""
                                })
                                : (<Box height={heightNo} display="flex" justifyContent="center" className="full-w-align-c">
                                    <Box className="full-w-align-c">No Record Found</Box>
                                </Box>)}
                        </Box>
                    </TabPanel>
                    <TabPanel value={value} index={2}>
                        <Box component="div" display="flex" pb={2} alignItems="center">
                            {totAnalysisReportStatus.length && totArray.length
                                ? totAnalysisReportStatus[0].typeOfCase.map((item) => (
                                    <Box key={item.title} component="div" pr={2}>
                                        <svg height="10" width="10">
                                            <circle cx="5" cy="5" r="4" fill={item.color} />
                                        </svg>
                                        <Box component="span" pl={1}>
                                            {item.title}
                                        </Box>
                                    </Box>
                                ))
                                : ""}
                        </Box>
                        <Box
                            component="div"
                            display="flex"
                            style={{ cursor: "pointer" }}
                        >
                            {totAnalysisReportStatus.length && totArray.length
                                ? totAnalysisReportStatus.map((item) => {
                                    const itemList = item.typeOfCase.filter(item => item.value != 0);
                                    return itemList.length ? (
                                        <Box
                                            component="div"
                                            style={{ cursor: "pointer" }}
                                            key={item.title + Math.random() * 100}
                                            onClick={() => {
                                                // onReportDetails(reportObj, "ReportStatus", "Tot");
                                            }}
                                        >
                                            <PipeChatSamll
                                                typeOfCase={item.typeOfCase}
                                                caseCount={item.caseCount}
                                                text1={item.text1}
                                                text2={item.text2}
                                            />
                                            <Box
                                                component="span"
                                                fontWeight="bold"
                                                fontSize={20}
                                                py={1}
                                                display="block"
                                                textAlign="center"
                                            >
                                                {item.title}
                                            </Box>
                                        </Box>
                                    ) : ""
                                })
                                : (<Box height={heightNo} display="flex" justifyContent="center" className="full-w-align-c">
                                    <Box className="full-w-align-c">No Record Found</Box>
                                </Box>)}
                        </Box>
                    </TabPanel>
                </Paper>
            </Box>
        </div>
    );
}
